import HomeComp from '../component/swipLogin';

export default function ({ appEnv }) {
  return <HomeComp appEnv={appEnv} />;
}

export async function getServerSideProps() {
  return {
    props: {
      omiEnv: process.env.OMI_ENV || '',
      nodeEnv: process.env.NODE_ENV || '',
      appEnv: process.env.APP_ENV || '',
    },
  };
}
